import React from "react";

const ContainerLayout = ({ children }) => {
    return <div style={{ height: "100%" }}>{children}</div>;
};

export default ContainerLayout;
